import store from '@/store'

// 無料トライアルお申込み画面
const trialRegistration = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: {
    email: ''
  },
  getters: {
  },
  mutations: {
    setEmail(state, email) {
      state.email = email
    }
  },
  actions: {
    /**
     * 初期表示の前の認証処理
     * ユーザーが受信メールのURLをクリックしてアクセスしたとき、
     * URLのクエリ文字列として付与されているトークンで認証処理を行う。
     * なお、このメソッドは、Vue Routerの対象ルーティング設定のbeforeEnter()メソッドから実行される。
     */
    async checkToken({ commit }, token) {
      let isAuthorized = false

      if (token !== '') {
        // プロフィール取得APIをコール
        const params = {}
        params.token = token

        await store
          .dispatch('profile/fetch', params)
          .then(async(map) => {
            const { response, error } = map
            if (response) {
              const { data } = response

              if (data.status === 0) {
                // 認証成功
                isAuthorized = true

                const email = data.email ?? ''

                // Eメールを保持(画面表示に使用する)
                await commit('setEmail', email)

                // ストアデータのauth/tokenにトークンを設定し保持する
                await store.dispatch('auth/setToken', { token: token, refreshToken: '' })
              }
            } 
          })
      }

      return isAuthorized
    }
  }
}

export default trialRegistration
